import { ICollider } from "../Physics/ICollider";

export class ElementData {
    public readonly asset: string;
    public readonly sheet: string | undefined;
    public readonly flippable: boolean;
    public readonly collision: boolean;
    public readonly collider: ICollider | undefined;
    public readonly funFact: string | undefined;
    public readonly collisionSfx: string | string[] | undefined;

    constructor(pAsset: string, pSheet?: string, pFlippable: boolean = true, pCollision: boolean = false,
                pCollider?: ICollider, pFunFact?: string, pCollisionSfx?: string | string[]) {
        this.asset = pAsset;
        this.sheet = pSheet;
        this.collision = pCollision;
        this.flippable = pFlippable;
        this.collider = pCollider;
        this.funFact = pFunFact;
        this.collisionSfx = pCollisionSfx;
    }
}
